import type { ReactElement } from 'react';
import { IconFileAttachmentOutlined } from '@repo/monochrome-icons';
import { scanAttachment } from '../../../assets/lotties';
import { LottiePlayer } from '../../lottie-player/lottie-player';
import type { AttachmentProcessingProps } from '../types';
import { Layout } from '../shared/layout';
import { Subtitle } from '../shared/subtitle';
import { Title } from '../shared/title';
import styles from './processing.module.css';

export function AttachmentProcessing({
  className,
  endContent,
  icon: Icon = IconFileAttachmentOutlined,
  title,
  subtitle,
  ...props
}: AttachmentProcessingProps): ReactElement {
  return (
    <Layout
      className={className}
      data-testid="attachment-processing"
      endContent={endContent}
      icon={
        <div className={styles.iconContainer}>
          <Icon height={24} width={24} />
          <LottiePlayer
            animationData={scanAttachment}
            autoplay
            className={styles.lottieIllustration}
            loop
          />
        </div>
      }
      {...props}
    >
      <Title>{title}</Title>
      <Subtitle className={styles.subtitle}>{subtitle}</Subtitle>
    </Layout>
  );
}
